module.exports = __webpack_public_path__ + "static/media/no-images.1a35dd96.png";